import axios from "axios";

export const state = {
    permissions: [],
};

export const getters = {
    permissions: state => state.permissions,
};

export const mutations = {
    setPermissions(permissions, newValue) {
        state.permissions = newValue
    },
};

export const actions = {
    async fetchPermissions({ commit }) {
        await axios.get('/permissions').then(res => {
            commit('setPermissions', res.data.permissions)
        })
    },
};
